import { Box, IconButton, Typography } from "@mui/material";
import { toggleSidebar } from "../../utils/utils";
import MenuIcon from "@mui/icons-material/Menu";
import { useLocation } from "react-router-dom";
import { useGetServerInfoQuery } from "../../services/vendor/VendorApi";


const CwcLogoBanner = () => {
  const location = useLocation();
  const department = localStorage?.getItem("department");
  const position = localStorage?.getItem("position");
  const { data: serverInfo } = useGetServerInfoQuery(0);

  // console.log(serverInfo?.server_ip)
  return (
    <Box
      sx={{
        display: "flex",
        position: "sticky",
        top: 0,
        justifyContent: { xs: "center", md: "space-between" },
        alignItems: "center",
        // right: 0,
        zIndex: 1001,
        background: "white",
        px: "30px",
        py: "4px",
        gap: 2,
        fontFamily: "Noto Sans, sans-serif",
        borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
      }}
      style={{ background: "#f8f9fa" }}
    >
      <style>{`
        body {
          background:white;
        }
      `}</style>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        {location?.pathname !== "/login" && (
          <Box
            sx={{
              display: { xs: "flex", md: "none" },
              position: "absolute",
              left: "5px",
            }}
          >
            <IconButton size="large" aria-label="account of current user" aria-controls="menu-appbar" aria-haspopup="true" onClick={toggleSidebar} color="inherit">
              <MenuIcon />
            </IconButton>
          </Box>
        )}

        <Box
          sx={{
            display: { xs: "none", md: "block" },
          }}
        >
          <img
            src="/image.png"
            alt="Central Warehousing Corporation logo"
            style={{
              objectFit: "cover",
              height: "70px",
            }}
          />
        </Box>
        {/* <Box
          component="img"
          sx={{
            height: 70,
          }}
          alt="Accenture Logo"
          src="acc-long-logo.png"
        /> */}
      </Box>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <Box sx={{ lineHeight: 1.15, textAlign: "center", margin: "auto" }}>
          <Typography
            sx={{
              fontFamily: "Noto Sans Devanagari, sans-serif",
              fontWeight: 700,
            }}
          >
            केंद्रीय भण्डारण निगम
          </Typography>
          <Typography sx={{ fontFamily: "Noto Sans Devanagari, sans-serif", mt: -0.5 }}>( भारत सरकार का उपक्रम )</Typography>
          <Typography sx={{ fontWeight: 700 }}>CENTRAL WAREHOUSING CORPORATION</Typography>
          <Typography sx={{ mt: -0.5 }}>(A GOVERNMENT OF INDIA UNDERTAKING)</Typography>
        </Box>

        <Box
          sx={{
            lineHeight: 1.15,
            pl: 2,
            ml: 2,
            borderLeft: "2px solid",
            borderColor: "text.primary",
            display: { xs: "none", md: "block" },
            maxHeight: "fit-content",
          }}
        >
          <Typography sx={{ fontWeight: 700 }}>WAREHOUSING FOR EVERYONE</Typography>
          <Typography sx={{ fontFamily: "Noto Sans Devanagari, sans-serif", mt: -0.5 }}>जन जन के लिए भण्डारण</Typography>
        </Box>
      </Box>
      {!(location?.pathname !== "/login" && localStorage?.getItem("userRole") === "employee") && <Box sx={{ display: { xs: "none", md: "flex" }, flexDirection: "column" }}></Box>}
      {location?.pathname !== "/login" && localStorage?.getItem("userRole") === "employee" && (
        <Box sx={{ display: { xs: "none", md: "flex" }, flexDirection: "column" }}>
          <div>
            Welcome, <span title={serverInfo?.server_ip} style={{
              cursor: 'pointer', width: '20px', height: '20px', borderRadius: '50%',
              position: 'absolute', border: '1px solid black', textAlign: 'center', lineHeight: '20px'
            }}>i</span><br />
            {localStorage?.getItem("employee_name")} <br />({localStorage?.getItem("employee_id")})
          </div>
          {/* <div>Department: {department ?? "NA"}</div>
          <div>Designation: {position ?? "NA"}</div> */}
        </Box>
      )}
      <></>
    </Box>
  );
};

export default CwcLogoBanner;
